export default "__VITE_ASSET__Dr4EYcm0__"